import { Component, OnInit, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseDataService, ModelData, NotificationService, TableRowColor} from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { SpisakIskoriscenih } from './spisak-iskoriscenih';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-spisak-iskoriscenih',
  templateUrl: './spisak-iskoriscenih.component.html'
})
export class SpisakIskoriscenihComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  ) { }

  Config={};
  items = [];
  modelData: ModelData;
  @Input() Parameters;
  rowColors: TableRowColor[];

  ngOnInit() {    
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
    }
    // this.baseDataService.Get('OdabirDokumenata','GetDokumenteByFakDokumentID',this.Parameters,SpisakDokumenata)
    // .subscribe(data => {
    //   this.items = data;
    //   this.Config={
    //     EditIcon: {
    //       Visible: false
    //     },
    //     DeleteIcon: {
    //       Visible: false
    //     },
    //     DefaultSortKey: this.modelData.MainList.SortBy,
    //     DefaultSortReverse: this.modelData.MainList.SortReverse,
    //     ShowIndex: false,
    //     ShowDefaultListButtons: false,
    //     ShowCheckBoxes: true,
    //     PrintIcon: {
    //       Visible: false
    //     }
    //     ,BreadCrumble: this.modelData.BreadcrumbLabel
    //   }
    // });
  }

  ngAfterViewInit(){  
    this.SpisakIskoriscenih(this.Parameters[0].Value);
    // this.rowColors = [    
    //   { 
    //     ColumnName: 'ObjekatID',
    //     Condition: ConditionType.Equals,
    //     Value: this.Parameters==undefined ? 0 : this.Parameters[3].Value==null ? 0 : this.Parameters[3].Value,
    //     Color: '#fed9ca'
    //   },
    //   { 
    //     ColumnName: 'VezaDokID',
    //     Condition: ConditionType.GreaterThan,
    //     Value: 0,
    //     Color: '#BEBEBE'
    //   }
    // ];
  }

  SpisakIskoriscenih(id:number){
    this.baseDataService.Get('FakDokument','GetSpisakDokumenataByFakDokumentID',this.Parameters,SpisakIskoriscenih)
    .subscribe(data => {
      this.items = data;
      // this.Config={
      //   EditIcon: {
      //     Visible: false
      //   },
      //   DeleteIcon: {
      //     Visible: false
      //   },
      //   DefaultSortKey: this.modelData.MainList.SortBy,
      //   DefaultSortReverse: this.modelData.MainList.SortReverse,
      //   ShowIndex: false,
      //   ShowDefaultListButtons: false,
      //   ShowCheckBoxes: false,
      //   PrintIcon: {
      //     Visible: false
      //   }
      //   ,BreadCrumble: this.modelData.BreadcrumbLabel
      // }
    });

  
  }

  
 
  Close(){
    this.activeModal.dismiss();
  }

 

}

